import React, { FC } from "react";
import { useFormikContext } from "formik";
import { FormField, useDidMount } from "@epcnetwork/core-ui-kit";

import { EGoiType, InitialValues } from "../secrets-form.types";

const EGoi: FC = () => {
  const { values, setFieldValue } = useFormikContext<InitialValues<EGoiType>>();

  useDidMount(() => {
    const eGoiValues = values.apiTypeContent;
    !eGoiValues?.apiKey && setFieldValue("apiTypeContent.apiKey", "");
  });

  return (
    <>
      <FormField type="text" name="apiTypeContent.apiKey" label="API KEY" placeholder="" required />
    </>
  );
};

export default EGoi;
